import script from "./statistic-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./statistic-widget-ly.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__